<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="wipEntityName"
          :value.sync="queryParams.wipEntityName"
          selectType="selectSearch"
          requestApi="/mes/mesDiscreteJobs/allWipEntityName"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="wipEntityName"
        />
        <global-select
          v-decorator="['desOrganizationCode', { rules: [{ required: true }] }]"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="desOrganizationCode"
          :value.sync="queryParams.desOrganizationCode"
          selectType="select"
          @init-success-call-back="handleDesOrganizationCodeSuccess"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <global-select
          slot="status"
          :value.sync="queryParams.status"
          selectType="selectFilter"
          requestApi="/mes/componentCenterOutOfStock/statusCombobox"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <a-select slot="pbQuantity" v-model="queryParams.pbQuantity" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
        <a-select slot="mlQuantity" v-model="queryParams.mlQuantity" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
        <a-select slot="kmQuantity" v-model="queryParams.kmQuantity" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
        <a-select slot="cbQuantity" v-model="queryParams.cbQuantity" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
        <a-select slot="ccQuantity" v-model="queryParams.ccQuantity" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
        <a-select slot="wjQuantity" v-model="queryParams.wjQuantity" allowClear>
          <a-select-option :value="'ltZero'">小于0</a-select-option>
          <a-select-option :value="'eqZero'">等于0</a-select-option>
          <a-select-option :value="'gtZero'">大于0</a-select-option>
        </a-select>
        <a-select slot="neatStatus" v-model="queryParams.neatStatus" allowClear>
          <a-select-option :value="'Y'">Y</a-select-option>
          <a-select-option :value="'N'">N</a-select-option>
        </a-select>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" @click="handleExport"
                  v-hasPermi="['mes:componentCenterOutOfStock:export']">导出</a-button>
        <download-modal :apiFun="apiComponentCenterOutOfStockExport" ref="download" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MATERIAL_SHORTAGE_ASSEMBLY_CENTER_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="quantityColor" slot-scope="{ text }">
            <span :class="{ 'green-bg': parseFloat(text) === 0 }">{{ text }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetComponentCenterOutOfStockList, apiComponentCenterOutOfStockExport } from '@/api/report/material-shortage-assembly-center'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Material-shortage-assembly-center', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode,
      inventOrg: (state) => state.user.inventOrg
    })
  },
  data () {
    return {
      apiComponentCenterOutOfStockExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetComponentCenterOutOfStockList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        desOrganizationCode: undefined,
        wipEntityName: undefined,
        itemCode: undefined,
        workCode: undefined,
        itemName: undefined,
        deliveryDate: undefined,
        deliveryDateFrom: undefined,
        deliveryDateTo: undefined,
        orderNo: undefined,
        pbQuantity: undefined,
        mlQuantity: undefined,
        organizationName: undefined,
        scheduledStartDate: undefined,
        scheduledStartDateFrom: undefined,
        scheduledStartDateTo: undefined,
        scheduledCompletionDate: undefined,
        scheduledCompletionDateFrom: undefined,
        scheduledCompletionDateTo: undefined,
        ccQuantity: undefined,
        kmQuantity: undefined,
        cbQuantity: undefined,
        wjQuantity: undefined,
        status: undefined,
        neatStatus: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '组织编码', decorator: ['desOrganizationCode'], type: 'desOrganizationCode' },
        { label: '工单号', decorator: ['wipEntityName'], type: 'wipEntityName' },
        { label: '物料编码', decorator: ['itemCode'], type: 'input' },
        { label: '所属车间编码', decorator: ['workCode'], type: 'input' },
        { label: '物料名称', decorator: ['itemName'], type: 'input' },
        {
          label: '一次考核交期',
          type: 'range',
          decorator: ['deliveryDate'],
          disposeFormat: {
            deliveryDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            deliveryDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        { label: '计划单号', decorator: ['orderNo'], type: 'input' },
        { label: '库存组织名称', decorator: ['organizationName'], type: 'input' },
        {
          label: '计划开始时间',
          type: 'range',
          decorator: ['scheduledStartDate'],
          disposeFormat: {
            scheduledStartDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            scheduledStartDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '计划完成时间',
          type: 'range',
          decorator: ['scheduledCompletionDate'],
          disposeFormat: {
            scheduledCompletionDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            scheduledCompletionDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        { label: '工单状态', decorator: ['status'], type: 'status' },
        { label: 'PB缺料数', decorator: ['pbQuantity'], type: 'pbQuantity' },
        { label: 'ML缺料数', decorator: ['mlQuantity'], type: 'mlQuantity' },
        { label: 'KM缺料数', decorator: ['kmQuantity'], type: 'kmQuantity' },
        { label: 'CB缺料数', decorator: ['cbQuantity'], type: 'cbQuantity' },
        { label: 'CC缺料数', decorator: ['ccQuantity'], type: 'ccQuantity' },
        { label: '五金箱缺料数', decorator: ['wjQuantity'], type: 'wjQuantity' },
        { label: '齐套状态', decorator: ['neatStatus'], type: 'neatStatus' }
      ],
      // 表格字段
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'orderNo',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        { title: '计划开始时间', dataIndex: 'scheduledStartDate', align: 'center', width: 150 },
        {
          title: '计划完成时间',
          dataIndex: 'scheduledCompletionDate',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        { title: '一次考核交期', dataIndex: 'deliveryDate', align: 'center', width: 150 },
        {
          title: '所属车间编码',
          dataIndex: 'workCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '所属车间',
          dataIndex: 'workshopDesc',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划数量',
          dataIndex: 'planQuantity',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: 'PB缺料数',
          dataIndex: 'pbQuantity',
          scopedSlots: { customRender: 'quantityColor' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: 'ML缺料数',
          dataIndex: 'mlQuantity',
          scopedSlots: { customRender: 'quantityColor' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: 'KM缺料数',
          dataIndex: 'kmQuantity',
          scopedSlots: { customRender: 'quantityColor' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: 'CB缺料数',
          dataIndex: 'cbQuantity',
          scopedSlots: { customRender: 'quantityColor' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        { title: 'CC缺料数', dataIndex: 'ccQuantity', scopedSlots: { customRender: 'quantityColor' }, align: 'center', width: 100 },
        { title: '五金箱缺料数', dataIndex: 'wjQuantity', scopedSlots: { customRender: 'quantityColor' }, align: 'center', width: 100 },
        {
          title: '齐套状态',
          dataIndex: 'neatStatus',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        { title: '订单齐套数', dataIndex: 'matchingQty', align: 'center', width: 100 },
        { title: '订单齐套率', dataIndex: 'matchingRate', align: 'center', width: 100 },
        {
          title: '组织编码',
          dataIndex: 'desOrganizationCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '库存组织名称',
          dataIndex: 'organizationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        // {
        //   title: '交货日期',
        //   dataIndex: 'deliveryDate',
        //   align: 'center',
        //   width: 150,
        //   ellipsis: true
        // },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          width: 260,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          width: 500,
          ellipsis: true
        }
      ]
    }
  },
  created () {
    // 处理缓存逻辑
    this.getHistoryCache(
      'refSearchForm',
      'desOrganizationCode',
      { deliveryDate: ['deliveryDateFrom', 'deliveryDateTo'], scheduledStartDate: ['scheduledStartDateFrom', 'scheduledStartDateTo'], scheduledCompletionDate: ['scheduledCompletionDateFrom', 'scheduledCompletionDateTo'] }
    )
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      if (!this.queryParams.desOrganizationCode) {
        this.$message.warning('请先选择组织编码')
        return;
      }
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        desOrganizationCode: undefined,
        wipEntityName: undefined,
        itemCode: undefined,
        workCode: undefined,
        itemName: undefined,
        deliveryDate: undefined,
        deliveryDateFrom: undefined,
        deliveryDateTo: undefined,
        orderNo: undefined,
        pbQuantity: undefined,
        mlQuantity: undefined,
        organizationName: undefined,
        scheduledStartDate: undefined,
        scheduledStartDateFrom: undefined,
        scheduledStartDateTo: undefined,
        scheduledCompletionDate: undefined,
        scheduledCompletionDateFrom: undefined,
        scheduledCompletionDateTo: undefined,
        ccQuantity: undefined,
        kmQuantity: undefined,
        cbQuantity: undefined,
        wjQuantity: undefined,
        status: undefined,
        neatStatus: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)

      // this.download('inv/invOnhandQuantities/wmsStockQtyExport', this.$refs.dataTable.searchParams, `库存余额_${new Date().getTime()}.xlsx`)
    },
    handleDesOrganizationCodeSuccess () {
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="less">
.page-header-content {
  /deep/.ant-table-tbody > tr > td:has(.green-bg) {
    background-color: rgb(126, 210, 51);
  }
}
</style>
